<script>
	const Vue = require('vue');
	const optimizedResize = require('utilities/optimizedResize');

	module.exports = {
		data() {
			return {
				overflow: false,
				scrollX: 0,
				observer: null,
				itemWidth: 10,
				focusedButton: undefined
			};
		},
		mounted() {
			this.observer = new MutationObserver(this.needToShowArrows);

			optimizedResize.add(this.needToShowArrows);

			Vue.nextTick(() => {
				this.needToShowArrows();

				if (this.observer) {
					// observe when tabs change
					this.observer.observe(this.$refs.itemList, {
						childList: true
					});
				}
			});
		},
		beforeDestroy() {
			optimizedResize.remove(this.needToShowArrows);

			// stop observing
			if (this.observer) {
				this.observer.disconnect();
			}
		},
		computed: {
			showLeftArrow() {
				return this.overflow && this.scrollX !== 0;
			},
			showRightArrow() {
				let el = this.$refs.container;
				return this.overflow && this.scrollX !== el.scrollWidth - el.offsetWidth;
			}
		},
		watch: {
			showLeftArrow(value) {
				this.onButtonRenderChange('left', value);
			},
			showRightArrow(value) {
				this.onButtonRenderChange('right', value);
			}
		},
		methods: {
			needToShowArrows() {
				let el = this.$refs.container;
				let list = this.$refs.itemList;
				this.overflow = false;

				if (el && el.offsetWidth < el.scrollWidth) {
					this.overflow = true;
				}
				if (list && list.children && list.children.length) {
					let firstChild = list.children[list.children.length - 1];
					this.itemWidth = firstChild.offsetWidth;
				}
				this.onContainerScroll();
			},
			onContainerScroll() {
				let el = this.$refs.container;
				if (el) {
					this.scrollX = el.scrollLeft;
				}
			},
			onLeftArrowClick() {
				let el = this.$refs.container;

				if (el) {
					let scroll = el.scrollLeft;

					scroll -= this.itemWidth * 3;

					el.scrollLeft = scroll < 0 ? 0 : scroll;
				}
			},
			onRightArrowClick() {
				let el = this.$refs.container;
				if (el) {
					let maxScroll = el.scrollWidth - el.offsetWidth;
					let scroll = el.scrollLeft;

					scroll += this.itemWidth * 3;

					el.scrollLeft = scroll > maxScroll ? maxScroll : scroll;
				}
			},
			handleButtonFocus(event) {
				const { target } = event;
				this.focusedButton = target.classList.contains('left-tab-arrow') ? 'left' : 'right';
			},
			handleButtonBlur(event) {
				Vue.nextTick(() => {
					this.focusedButton = undefined;
				});
			},
			onButtonRenderChange(button, rendered) {
				if (rendered === false && this.focusedButton === button) {
					this.$el.focus();
					this.focusedButton = undefined;
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.multi-item-carousel {
		position: relative;

		.tab-arrow {
			position: absolute;
			top: 0;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			font-size: 2rem;
			z-index: 2;
			background-color: rgba(245, 248, 248, 0.8);
			border: none;

			&.right-tab-arrow {
				right: 0;
			}

			&.left-tab-arrow {
				left: 0;
			}

			i {
				border: 1px solid #dcdee0;
				padding: 1.25rem 0.8rem;
				border-radius: 5rem;
				line-height: 0;
				color: $c-blue;
				background-color: $c-white;
			}

			&:hover {
				i {
					color: $c-slate-dark;
				}
			}
		}

		.carousel-outer-container {
			overflow-x: scroll;
			white-space: nowrap;
			scroll-behavior: smooth;
			-ms-overflow-style: none; // IE 10+
			scrollbar-width: none; // Firefox

			&::-webkit-scrollbar {
				width: 0px;
				background: transparent;
			}

			&::-webkit-scrollbar-thumb {
				background: $c-grey;
			}

			.carousel-inner-container > * {
				white-space: normal;
				vertical-align: top;
			}
		}
	}

	@media only screen and (min-width: $bp-width-lg+(17px*6)) {
		.multi-item-carousel {
			.tab-arrow {
				width: 3rem;
				background-color: $c-white;

				&.right-tab-arrow {
					right: -3rem;
					background-image: none;
					justify-content: flex-end;
				}

				&.left-tab-arrow {
					left: -3rem;
					background-image: none;
					justify-content: flex-start;
				}
			}
		}
	}
</style>
<template>
	<div
		class="multi-item-carousel"
		tabindex="-1">
		<button
			v-if="showLeftArrow"
			@click="onLeftArrowClick"
			@focus="handleButtonFocus"
			@blur="handleButtonBlur"
			class="tab-arrow left-tab-arrow"
			aria-label="Show previous">
			<i class="fa-solid fa-angle-left"></i>
		</button>
		<div
			class="carousel-outer-container"
			@scroll="onContainerScroll"
			ref="container">
			<div
				class="carousel-inner-container"
				ref="itemList">
				<slot></slot>
			</div>
		</div>
		<button
			v-if="showRightArrow"
			@click="onRightArrowClick"
			@focus="handleButtonFocus"
			@blur="handleButtonBlur"
			class="tab-arrow right-tab-arrow"
			aria-label="Show next">
			<i class="fa-solid fa-angle-right"></i>
		</button>
	</div>
</template>
